import { env } from "../constants/env";

export const getCloudTracking = async (login) => {
  const response = await fetch(
    `${env.primeBridgeUrl}/api/cloud-tracking/${login}`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch cloud tracking data");
  }
  console.log("CLOUD TRACKING RESPONSE", response);
  return await response.json();
};

export const getLiveTracking = async (login) => {                                                                                   
    if (!login) return {};                                                                                                            
    const res = await fetch(`${env.primeBridgeUrl}/api/live-tracking/${login}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) return {};
    return res.json();
  };

export const fetchPaginated = async (login, type, page = 1, limit = 10) => {
  const res = await fetch(
    `${env.primeBridgeUrl}/api/cloud-tracking/${login}/${type}?page=${page}&limit=${limit}`
  );
  const result = await res.json();
  console.log(`${type} Page ${result.page}:`, result.data);
  console.log(`Total: ${result.total} | Pages: ${result.totalPages}`);
  return {
    data: result.data,
    page: result.page,
    total: result.total,
    totalPages: result.totalPages,
  };
};

export const getDailyBalance = async (login) => {
  if (!login) return [];
  const res = await fetch(`${env.primeBridgeUrl}/api/cloud-tracking/daily-chart/${login}/balance`);
 
  if (!res.ok) throw new Error("Failed to fetch balance");
  return res.json();
};

export const getDailyDrawdown = async (login) => {
  if (!login) return [];
  const res = await fetch(`${env.primeBridgeUrl}/api/cloud-tracking/daily-chart/${login}/drawdown`);
  if (!res.ok) throw new Error("Failed to fetch drawdown");
  return res.json();
};

export const getDailyEquity = async (login) => {
  if (!login) return [];
  const res = await fetch(`${env.primeBridgeUrl}/api/cloud-tracking/daily-chart/${login}/equity`);
  if (!res.ok) throw new Error("Failed to fetch equity");
  return res.json();
};
